function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint no-console: "off" */
import { ERROR, WARN, INFO, DEBUG, DEBUG2 } from "./LoggerLevel.js";
var silent = () => undefined;
class Logger {
  constructor(name, level) {
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "prefix", void 0);
    _defineProperty(this, "level", void 0);
    _defineProperty(this, "error", void 0);
    _defineProperty(this, "warn", void 0);
    _defineProperty(this, "log", void 0);
    _defineProperty(this, "info", void 0);
    _defineProperty(this, "debug", void 0);
    _defineProperty(this, "debug2", void 0);
    this.name = name;
    this.prefix = name != null ? "[".concat(name, "]") : "";
    this.error = silent;
    this.warn = silent;
    this.log = silent;
    this.info = silent;
    this.debug = silent;
    this.debug2 = silent;
    this.level = level;
    this.setLogLevel(level);
  }
  setLogLevel(level) {
    if (!Number.isFinite(level)) {
      console.warn("Expected a number for log level. Received: ".concat(level, ". Ignoring"));
      return;
    }
    this.level = level;
    this.error = level >= ERROR ? console.error.bind(console, this.prefix) : silent;
    this.warn = level >= WARN ? console.warn.bind(console, this.prefix) : silent;
    this.log = level >= INFO ? console.log.bind(console, this.prefix) : silent;
    this.info = this.log;
    this.debug = level >= DEBUG ? console.debug.bind(console, this.prefix) : silent;
    this.debug2 = level >= DEBUG2 ? console.debug.bind(console, this.prefix) : silent;
  }
}
export default Logger;
//# sourceMappingURL=Logger.js.map